import { render } from "./BookTrust.vue?vue&type=template&id=703fb190&scoped=true"
import script from "./BookTrust.vue?vue&type=script&lang=js"
export * from "./BookTrust.vue?vue&type=script&lang=js"

import "./BookTrust.vue?vue&type=style&index=0&id=703fb190&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-703fb190"]])

export default __exports__